import React, { useState, useEffect } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import api from '../../services/api';
import {
  FaHome, FaCog, FaImages, FaTools, FaFile,
  FaCamera, FaEnvelope, FaSignOutAlt, FaBars, FaSortNumericUp,
  FaQuoteLeft, FaExchangeAlt, FaClipboardList,
  FaHistory, FaUsersCog, FaBell, FaMoon, FaSun, FaPhotoVideo
} from 'react-icons/fa';
import { useTheme } from '../../context/ThemeContext';
import '../admin.css';

const navItems = [
  { to: '/admin', icon: <FaHome />, label: 'Dashboard', end: true },
  { to: '/admin/ayarlar', icon: <FaCog />, label: 'Site Ayarlari' },
  { to: '/admin/slider', icon: <FaImages />, label: 'Slider' },
  { to: '/admin/hizmetler', icon: <FaTools />, label: 'Hizmetler' },
  { to: '/admin/sayfalar', icon: <FaFile />, label: 'Sayfalar' },
  { to: '/admin/sayaclar', icon: <FaSortNumericUp />, label: 'Rakamlar' },
  { to: '/admin/yorumlar', icon: <FaQuoteLeft />, label: 'Müşteriler' },
  { to: '/admin/once-sonra', icon: <FaExchangeAlt />, label: 'Once/Sonra' },
  { to: '/admin/referanslar', icon: <FaCamera />, label: 'Referanslar' },
  { to: '/admin/medya', icon: <FaPhotoVideo />, label: 'Medya' },
  { to: '/admin/mesajlar', icon: <FaEnvelope />, label: 'Mesajlar' },
  { to: '/admin/teklifler', icon: <FaClipboardList />, label: 'Teklifler' },
  { to: '/admin/aktivite', icon: <FaHistory />, label: 'Aktivite Logu' },
  { to: '/admin/kullanicilar', icon: <FaUsersCog />, label: 'Kullanicilar' },
];

export default function AdminLayout() {
  const { user, logout, loading } = useAuth();
  const navigate = useNavigate();
  const { theme, toggleTheme } = useTheme();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [pendingReviews, setPendingReviews] = useState(0);

  useEffect(() => {
    if (!loading && !user) {
      navigate('/admin/login');
    }
  }, [user, loading, navigate]);

  useEffect(() => {
    if (user) {
      const fetchPending = () => {
        api.get('/testimonials/pending-count')
          .then(res => setPendingReviews(res.data.count || 0))
          .catch(() => {});
      };
      fetchPending();
      const interval = setInterval(fetchPending, 30000);
      return () => clearInterval(interval);
    }
  }, [user]);

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  if (loading) {
    return <div className="admin-loading">Yukleniyor...</div>;
  }

  if (!user) {
    return null;
  }

  return (
    <div className="admin-layout">
      <div
        className={`sidebar-overlay ${sidebarOpen ? 'active' : ''}`}
        onClick={() => setSidebarOpen(false)}
      />

      <aside className={`admin-sidebar ${sidebarOpen ? 'open' : ''}`}>
        <div className="admin-sidebar-header">
          <h2>Yonetim Paneli</h2>
          <p>CMS</p>
        </div>
        <nav className="admin-sidebar-nav">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) => (isActive ? 'active' : '')}
              onClick={() => setSidebarOpen(false)}
            >
              {item.icon}
              {item.label}
            </NavLink>
          ))}
        </nav>
      </aside>

      <div className="admin-main">
        <header className="admin-topbar">
          <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
            <button
              className="admin-mobile-toggle"
              onClick={() => setSidebarOpen(!sidebarOpen)}
            >
              <FaBars />
            </button>
            <h1>Admin Panel</h1>
          </div>
          <div className="admin-topbar-right">
            <button
              className="admin-theme-toggle"
              onClick={toggleTheme}
              title={theme === 'dark' ? 'Acik moda gec' : 'Karanlik moda gec'}
            >
              {theme === 'dark' ? <FaSun /> : <FaMoon />}
            </button>
            {pendingReviews > 0 && (
              <button
                className="admin-notification-btn"
                onClick={() => navigate('/admin/yorumlar')}
                title={`${pendingReviews} onay bekleyen yorum`}
              >
                <FaBell />
                <span className="notification-badge">{pendingReviews}</span>
              </button>
            )}
            <span className="admin-topbar-user">
              {user.username}
            </span>
            <button className="btn-logout" onClick={handleLogout}>
              <FaSignOutAlt /> Çıkış
            </button>
          </div>
        </header>
        <div className="admin-content">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
